import React, {Component} from 'react';
import {swap, board, siteHelper} from "../../helpers/exportConsts";

class Solution extends Component {
  state = {
    arr: new Array(9).fill(1).map((_, i) => i + 1),
    currentIndex: 0,
    colorIndexing: new Array(9).fill('rgba(0, 0, 0, 0.341176)')
  };

  tg = 0;

  navigate = (solution, cdx) => {
    const arr =Array.from(this.state.arr);
    let move = solution[cdx];
    const colorIndexing = new Array(9).fill('rgba(0, 0, 0, 0.341176)');
    swap(arr, move.swapDirection, siteHelper[move.swapSite], colorIndexing);
    this.setState({
      ...this.state,
      arr,
      currentIndex: cdx,
      colorIndexing
    });
  };

  render() {
    const {solution, arr, changeGameState, target} = this.props;
    const cdx = this.state.currentIndex;
    let leftButtonBool, rightButtonBool;
    leftButtonBool = (cdx === 0);
    rightButtonBool = (cdx === solution.length-1);
    return(
      <div className={'gameboard py-3'}>
        <div className={'main'}>
          <div>
            <div className="px-3 py-3 mb-2">
              <h1 className={'text-center white'}><strong>Solution</strong></h1>
              <h5 className={'text-center white'}> Minimum moves : {target}</h5>
            </div>
            <div className="row">
              <div className="row flex-column justify-content-center">
                <button className={'navigate-btns'}
                        onClick={() => this.navigate(solution, this.state.currentIndex-1)}
                        disabled={leftButtonBool}>&#10094;</button>
              </div>
              <div className={'mt-3 mb-2 mr-3 ml-3'}>
                  {board(arr, this.state.arr, this.state.colorIndexing)}
              </div>
              <div className="row flex-column justify-content-center">
                <button className={'navigate-btns'}
                        onClick={() => this.navigate(solution, this.state.currentIndex+1)}
                        disabled={rightButtonBool}>&#10095;</button>
              </div>
            </div>
          </div>
        </div>
        <div className={'row justify-content-center'}>
          <button className={'action'} onClick={() => {changeGameState("gameOn", 0)}}>
            Start new game!</button>
        </div>
      </div>

    );
  }
}

export default Solution;